<template>
  <div class="tax-table-wrap tax-table-wrap-tax53" :class="[`tax-status-${taxData.status}`]" v-if="isInit">
    <dl class="tax-table-header">
      <dt>企业所得税年度纳税申报主表</dt>

      <dd></dd>
    </dl>

    <div class="tax-table-body">
      <table border="1" cellspacing="1" cellpadding="0" tabletype="2024033104">
        <thead>
          <tr>
            <td class="title01" width="5%">行次</td>
            <td class="title01" width="15%">类别</td>
            <td class="title01" width="60%">项目</td>
            <td class="title01" width="20%">金额</td>
          </tr>
        </thead>
        <tbody>
          <tr class="tr">
            <td class="title01">1</td>
            <td class="title01" rowspan="18">利润总额计算</td>
            <td class="title01">一、营业收入（填写A101010/101020/103000）</td>
            <td>
              <!-- 考题 -->
              <taxQue :data="data.v1x1" :mode="mode">
                <template #input>
                  <el-input-number v-model.trim="data.v1x1.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" />
                </template>
                <template #score>
                  <el-input-number placeholder="答案" class="score-wrap-answer" v-model.trim="data.v1x1.answer" :controls="false" :precision="2" :step="0.01" :value-on-clear="null" />
                  <el-input-number placeholder="分值" class="score-wrap-score" v-model.trim="data.v1x1.score" :controls="false" :precision="1" :step="0.1" :max="100" :min="0" :value-on-clear="null" />
                </template>
              </taxQue>
            </td>
          </tr>

          <tr class="tr">
            <td class="title01">2</td>
            <td class="title01" style="padding-left: 35px">减：营业成本（填写A102010/102020/103000）</td>
            <td>
              <!-- 考题 -->
              <taxQue :data="data.v2x1" :mode="mode">
                <template #input>
                  <el-input-number v-model.trim="data.v2x1.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" />
                </template>
                <template #score>
                  <el-input-number placeholder="答案" class="score-wrap-answer" v-model.trim="data.v2x1.answer" :controls="false" :precision="2" :step="0.01" :value-on-clear="null" />
                  <el-input-number placeholder="分值" class="score-wrap-score" v-model.trim="data.v2x1.score" :controls="false" :precision="1" :step="0.1" :max="100" :min="0" :value-on-clear="null" />
                </template>
              </taxQue>
            </td>
          </tr>

          <tr class="tr">
            <td class="title01">3</td>
            <td class="title01" style="padding-left: 35px">减：税金及附加</td>
            <td>
              <!-- 考题 -->
              <taxQue :data="data.v3x1" :mode="mode">
                <template #input>
                  <el-input-number v-model.trim="data.v3x1.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" />
                </template>
                <template #score>
                  <el-input-number placeholder="答案" class="score-wrap-answer" v-model.trim="data.v3x1.answer" :controls="false" :precision="2" :step="0.01" :value-on-clear="null" />
                  <el-input-number placeholder="分值" class="score-wrap-score" v-model.trim="data.v3x1.score" :controls="false" :precision="1" :step="0.1" :max="100" :min="0" :value-on-clear="null" />
                </template>
              </taxQue>
            </td>
          </tr>

          <tr class="tr">
            <td class="title01">4</td>
            <td class="title01" style="padding-left: 35px">减：销售费用（填写A104000）</td>
            <td>
              <!-- 考题 -->
              <taxQue :data="data.v4x1" :mode="mode">
                <template #input>
                  <el-input-number v-model.trim="data.v4x1.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" />
                </template>
                <template #score>
                  <el-input-number placeholder="答案" class="score-wrap-answer" v-model.trim="data.v4x1.answer" :controls="false" :precision="2" :step="0.01" :value-on-clear="null" />
                  <el-input-number placeholder="分值" class="score-wrap-score" v-model.trim="data.v4x1.score" :controls="false" :precision="1" :step="0.1" :max="100" :min="0" :value-on-clear="null" />
                </template>
              </taxQue>
            </td>
          </tr>

          <tr class="tr">
            <td class="title01">5</td>
            <td class="title01" style="padding-left: 35px">减：管理费用（填写A104000）</td>
            <td>
              <!-- 考题 -->
              <taxQue :data="data.v5x1" :mode="mode">
                <template #input>
                  <el-input-number v-model.trim="data.v5x1.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" />
                </template>
                <template #score>
                  <el-input-number placeholder="答案" class="score-wrap-answer" v-model.trim="data.v5x1.answer" :controls="false" :precision="2" :step="0.01" :value-on-clear="null" />
                  <el-input-number placeholder="分值" class="score-wrap-score" v-model.trim="data.v5x1.score" :controls="false" :precision="1" :step="0.1" :max="100" :min="0" :value-on-clear="null" />
                </template>
              </taxQue>
            </td>
          </tr>

          <tr class="tr">
            <td class="title01">6</td>
            <td class="title01" style="padding-left: 35px">减：研发费用（填写A104000）</td>
            <td>
              <!-- 考题 -->
              <taxQue :data="data.v6x1" :mode="mode">
                <template #input>
                  <el-input-number v-model.trim="data.v6x1.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" />
                </template>
                <template #score>
                  <el-input-number placeholder="答案" class="score-wrap-answer" v-model.trim="data.v6x1.answer" :controls="false" :precision="2" :step="0.01" :value-on-clear="null" />
                  <el-input-number placeholder="分值" class="score-wrap-score" v-model.trim="data.v6x1.score" :controls="false" :precision="1" :step="0.1" :max="100" :min="0" :value-on-clear="null" />
                </template>
              </taxQue>
            </td>
          </tr>

          <tr class="tr">
            <td class="title01">7</td>
            <td class="title01" style="padding-left: 35px">减：财务费用（填写A104000）</td>
            <td>
              <!-- 考题 -->
              <taxQue :data="data.v7x1" :mode="mode">
                <template #input>
                  <el-input-number v-model.trim="data.v7x1.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" />
                </template>
                <template #score>
                  <el-input-number placeholder="答案" class="score-wrap-answer" v-model.trim="data.v7x1.answer" :controls="false" :precision="2" :step="0.01" :value-on-clear="null" />
                  <el-input-number placeholder="分值" class="score-wrap-score" v-model.trim="data.v7x1.score" :controls="false" :precision="1" :step="0.1" :max="100" :min="0" :value-on-clear="null" />
                </template>
              </taxQue>
            </td>
          </tr>

          <tr class="tr">
            <td class="title01">8</td>
            <td class="title01" style="padding-left: 35px">加：其他收益</td>
            <td><el-input-number v-model.trim="data.v8x1.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" /></td>
          </tr>

          <tr class="tr">
            <td class="title01">9</td>
            <td class="title01" style="padding-left: 35px">加：投资收益（损失以‘－’号填列）</td>
            <td><el-input-number v-model.trim="data.v9x1.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" /></td>
          </tr>

          <tr class="tr">
            <td class="title01">10</td>
            <td class="title01" style="padding-left: 35px">加：净敞口套期收益（损失以‘－’号填列）</td>
            <td><el-input-number v-model.trim="data.v10x1.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" /></td>
          </tr>

          <tr class="tr">
            <td class="title01">11</td>
            <td class="title01" style="padding-left: 35px">加：公允价值变动收益（损失以‘－’号填列）</td>
            <td><el-input-number v-model.trim="data.v11x1.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" /></td>
          </tr>

          <tr class="tr">
            <td class="title01">12</td>
            <td class="title01" style="padding-left: 35px">加：信用减值损失（损失以‘－’号填列）</td>
            <td><el-input-number v-model.trim="data.v12x1.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" /></td>
          </tr>

          <tr class="tr">
            <td class="title01">13</td>
            <td class="title01" style="padding-left: 35px">加：资产减值损失（损失以‘－’号填列）</td>
            <td><el-input-number v-model.trim="data.v13x1.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" /></td>
          </tr>

          <tr class="tr">
            <td class="title01">14</td>
            <td class="title01" style="padding-left: 35px">加：资产处置收益（损失以‘－’号填列）</td>
            <td><el-input-number v-model.trim="data.v14x1.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" /></td>
          </tr>

          <tr class="tr">
            <td class="title01">15</td>
            <td class="title01">二、营业利润（亏损以‘－’号填列）</td>
            <td>
              <!-- 考题 -->
              <taxQue :data="data.v15x1" :mode="mode">
                <template #input>
                  {{ parseFloatNum(data.v15x1.value) }}
                </template>
                <template #score>
                  <el-input-number placeholder="答案" class="score-wrap-answer" v-model.trim="data.v15x1.answer" :controls="false" :precision="2" :step="0.01" :value-on-clear="null" />
                  <el-input-number
                    placeholder="分值"
                    class="score-wrap-score"
                    v-model.trim="data.v15x1.score"
                    :controls="false"
                    :precision="1"
                    :step="0.1"
                    :max="100"
                    :min="0"
                    :value-on-clear="null"
                  />
                </template>
              </taxQue>
            </td>
          </tr>

          <tr class="tr">
            <td class="title01">16</td>
            <td class="title01" style="padding-left: 35px">加：营业外收入（填写A101010/101020/103000）</td>
            <td>
              <!-- 考题 -->
              <taxQue :data="data.v16x1" :mode="mode">
                <template #input>
                  <el-input-number v-model.trim="data.v16x1.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" />
                </template>
                <template #score>
                  <el-input-number placeholder="答案" class="score-wrap-answer" v-model.trim="data.v16x1.answer" :controls="false" :precision="2" :step="0.01" :value-on-clear="null" />
                  <el-input-number
                    placeholder="分值"
                    class="score-wrap-score"
                    v-model.trim="data.v16x1.score"
                    :controls="false"
                    :precision="1"
                    :step="0.1"
                    :max="100"
                    :min="0"
                    :value-on-clear="null"
                  />
                </template>
              </taxQue>
            </td>
          </tr>

          <tr class="tr">
            <td class="title01">17</td>
            <td class="title01" style="padding-left: 35px">减：营业外支出（填写A102010/102020/103000）</td>
            <td>
              <!-- 考题 -->
              <taxQue :data="data.v17x1" :mode="mode">
                <template #input>
                  <el-input-number v-model.trim="data.v17x1.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" />
                </template>
                <template #score>
                  <el-input-number placeholder="答案" class="score-wrap-answer" v-model.trim="data.v17x1.answer" :controls="false" :precision="2" :step="0.01" :value-on-clear="null" />
                  <el-input-number
                    placeholder="分值"
                    class="score-wrap-score"
                    v-model.trim="data.v17x1.score"
                    :controls="false"
                    :precision="1"
                    :step="0.1"
                    :max="100"
                    :min="0"
                    :value-on-clear="null"
                  />
                </template>
              </taxQue>
            </td>
          </tr>

          <tr class="tr">
            <td class="title01">18</td>
            <td class="title01">三、利润总额（15＋16－17）</td>
            <td>
              <!-- 考题 -->
              <taxQue :data="data.v18x1" :mode="mode">
                <template #input>
                  {{ parseFloatNum(data.v18x1.value) }}
                </template>
                <template #score>
                  <el-input-number placeholder="答案" class="score-wrap-answer" v-model.trim="data.v18x1.answer" :controls="false" :precision="2" :step="0.01" :value-on-clear="null" />
                  <el-input-number
                    placeholder="分值"
                    class="score-wrap-score"
                    v-model.trim="data.v18x1.score"
                    :controls="false"
                    :precision="1"
                    :step="0.1"
                    :max="100"
                    :min="0"
                    :value-on-clear="null"
                  />
                </template>
              </taxQue>
            </td>
          </tr>

          <tr class="tr">
            <td class="title01">19</td>
            <td class="title01" rowspan="12">应纳税所得额计算</td>
            <td class="title01" style="padding-left: 35px">减：境外所得（填写A108010）</td>
            <td><el-input-number v-model.trim="data.v19x1.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" /></td>
          </tr>

          <tr class="tr">
            <td class="title01">20</td>
            <td class="title01" style="padding-left: 35px">加：纳税调整增加额（填写A105000）</td>
            <td>
              <!-- 关联数据 -->
              <!-- 纳税明细表46行-调增金额 -->
              <!-- 考题 -->
              <taxQue :data="data.v20x1" :mode="mode">
                <template #input>
                  {{ parseFloatNum(data.v20x1.value) }}
                </template>
                <template #score>
                  <el-input-number placeholder="答案" class="score-wrap-answer" v-model.trim="data.v20x1.answer" :controls="false" :precision="2" :step="0.01" :value-on-clear="null" />
                  <el-input-number
                    placeholder="分值"
                    class="score-wrap-score"
                    v-model.trim="data.v20x1.score"
                    :controls="false"
                    :precision="1"
                    :step="0.1"
                    :max="100"
                    :min="0"
                    :value-on-clear="null"
                  />
                </template>
              </taxQue>
            </td>
          </tr>

          <tr class="tr">
            <td class="title01">21</td>
            <td class="title01" style="padding-left: 35px">减：纳税调整减少额（填写A105000）</td>
            <td><el-input-number v-model.trim="data.v21x1.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" /></td>
          </tr>

          <tr class="tr">
            <td class="title01">22</td>
            <td class="title01" style="padding-left: 35px">减：免税、减计收入及加计扣除（22.1＋22.2＋…）</td>
            <td>
              <!-- 考题 -->
              <taxQue :data="data.v22x1" :mode="mode">
                <template #input>
                  {{ parseFloatNum(data.v22x1.value) }}
                </template>
                <template #score>
                  <el-input-number placeholder="答案" class="score-wrap-answer" v-model.trim="data.v22x1.answer" :controls="false" :precision="2" :step="0.01" :value-on-clear="null" />
                  <el-input-number
                    placeholder="分值"
                    class="score-wrap-score"
                    v-model.trim="data.v22x1.score"
                    :controls="false"
                    :precision="1"
                    :step="0.1"
                    :max="100"
                    :min="0"
                    :value-on-clear="null"
                  />
                </template>
              </taxQue>
            </td>
          </tr>

          <tr class="tr">
            <td class="title01">22.1</td>
            <td class="title01" style="padding-left: 35px">（填写优惠事项名称）</td>
            <td>
              <!-- 考题 -->
              <taxQue :data="data.v22_1x1" :mode="mode">
                <template #input>
                  <el-input-number v-model.trim="data.v22_1x1.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" />
                </template>
                <template #score>
                  <el-input-number placeholder="答案" class="score-wrap-answer" v-model.trim="data.v22_1x1.answer" :controls="false" :precision="2" :step="0.01" :value-on-clear="null" />
                  <el-input-number
                    placeholder="分值"
                    class="score-wrap-score"
                    v-model.trim="data.v22_1x1.score"
                    :controls="false"
                    :precision="1"
                    :step="0.1"
                    :max="100"
                    :min="0"
                    :value-on-clear="null"
                  />
                </template>
              </taxQue>
            </td>
          </tr>

          <tr class="tr">
            <td class="title01">22.2</td>
            <td class="title01" style="padding-left: 35px">（填写优惠事项名称）</td>
            <td>
              <!-- 考题 -->
              <taxQue :data="data.v22_2x1" :mode="mode">
                <template #input>
                  <el-input-number v-model.trim="data.v22_2x1.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" />
                </template>
                <template #score>
                  <el-input-number placeholder="答案" class="score-wrap-answer" v-model.trim="data.v22_2x1.answer" :controls="false" :precision="2" :step="0.01" :value-on-clear="null" />
                  <el-input-number
                    placeholder="分值"
                    class="score-wrap-score"
                    v-model.trim="data.v22_2x1.score"
                    :controls="false"
                    :precision="1"
                    :step="0.1"
                    :max="100"
                    :min="0"
                    :value-on-clear="null"
                  />
                </template>
              </taxQue>
            </td>
          </tr>

          <tr class="tr">
            <td class="title01">23</td>
            <td class="title01" style="padding-left: 35px">加：境外应税所得抵减境内亏损（填写A108000）</td>
            <td><el-input-number v-model.trim="data.v23x1.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" /></td>
          </tr>

          <tr class="tr">
            <td class="title01">24</td>
            <td class="title01">四、纳税调整后所得（18－19＋20－21－22＋23）</td>
            <td>
              <!-- 考题 -->
              <taxQue :data="data.v24x1" :mode="mode">
                <template #input>
                  {{ parseFloatNum(data.v24x1.value) }}
                </template>
                <template #score>
                  <el-input-number placeholder="答案" class="score-wrap-answer" v-model.trim="data.v24x1.answer" :controls="false" :precision="2" :step="0.01" :value-on-clear="null" />
                  <el-input-number
                    placeholder="分值"
                    class="score-wrap-score"
                    v-model.trim="data.v24x1.score"
                    :controls="false"
                    :precision="1"
                    :step="0.1"
                    :max="100"
                    :min="0"
                    :value-on-clear="null"
                  />
                </template>
              </taxQue>
            </td>
          </tr>

          <tr class="tr">
            <td class="title01">25</td>
            <td class="title01" style="padding-left: 35px">减：所得减免（填写A107020）</td>
            <td><el-input-number v-model.trim="data.v25x1.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" /></td>
          </tr>

          <tr class="tr">
            <td class="title01">26</td>
            <td class="title01" style="padding-left: 35px">减：弥补以前年度亏损（填写A106000）</td>
            <td>
              <!-- 关联数据 -->
              <!-- 关联弥补亏损表16行-使用境内所得弥补 -->
              <!-- 考题 -->
              <taxQue :data="data.v26x1" :mode="mode">
                <template #input>
                  {{ parseFloatNum(data.v26x1.value) }}
                </template>
                <template #score>
                  <el-input-number placeholder="答案" class="score-wrap-answer" v-model.trim="data.v26x1.answer" :controls="false" :precision="2" :step="0.01" :value-on-clear="null" />
                  <el-input-number
                    placeholder="分值"
                    class="score-wrap-score"
                    v-model.trim="data.v26x1.score"
                    :controls="false"
                    :precision="1"
                    :step="0.1"
                    :max="100"
                    :min="0"
                    :value-on-clear="null"
                  />
                </template>
              </taxQue>
            </td>
          </tr>

          <tr class="tr">
            <td class="title01">27</td>
            <td class="title01" style="padding-left: 35px">减：抵扣应纳税所得额（填写A107030）</td>
            <td><el-input-number v-model.trim="data.v27x1.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" /></td>
          </tr>

          <tr class="tr">
            <td class="title01">28</td>
            <td class="title01">五、应纳税所得额（24－25－26－27）</td>
            <td>
              <!-- 考题 -->
              <taxQue :data="data.v28x1" :mode="mode">
                <template #input>
                  {{ parseFloatNum(data.v28x1.value) }}
                </template>
                <template #score>
                  <el-input-number placeholder="答案" class="score-wrap-answer" v-model.trim="data.v28x1.answer" :controls="false" :precision="2" :step="0.01" :value-on-clear="null" />
                  <el-input-number
                    placeholder="分值"
                    class="score-wrap-score"
                    v-model.trim="data.v28x1.score"
                    :controls="false"
                    :precision="1"
                    :step="0.1"
                    :max="100"
                    :min="0"
                    :value-on-clear="null"
                  />
                </template>
              </taxQue>
            </td>
          </tr>

          <tr class="tr">
            <td class="title01">29</td>
            <td class="title01" rowspan="9">应纳税额计算</td>
            <td class="title01">税率（25%）</td>
            <td>{{ data.v29x1.value * 100 }}%</td>
          </tr>

          <tr class="tr">
            <td class="title01">30</td>
            <td class="title01">六、应纳所得税额（28×29）</td>
            <td>
              <!-- 考题 -->
              <taxQue :data="data.v30x1" :mode="mode">
                <template #input>
                  {{ parseFloatNum(data.v30x1.value) }}
                </template>
                <template #score>
                  <el-input-number placeholder="答案" class="score-wrap-answer" v-model.trim="data.v30x1.answer" :controls="false" :precision="2" :step="0.01" :value-on-clear="null" />
                  <el-input-number
                    placeholder="分值"
                    class="score-wrap-score"
                    v-model.trim="data.v30x1.score"
                    :controls="false"
                    :precision="1"
                    :step="0.1"
                    :max="100"
                    :min="0"
                    :value-on-clear="null"
                  />
                </template>
              </taxQue>
            </td>
          </tr>

          <tr class="tr">
            <td class="title01">31</td>
            <td class="title01" style="padding-left: 35px">减：减免所得税额（31.1＋31.2＋…）</td>
            <td>
              <!-- 考题 -->
              <taxQue :data="data.v31x1" :mode="mode">
                <template #input>
                  {{ parseFloatNum(data.v31x1.value) }}
                </template>
                <template #score>
                  <el-input-number placeholder="答案" class="score-wrap-answer" v-model.trim="data.v31x1.answer" :controls="false" :precision="2" :step="0.01" :value-on-clear="null" />
                  <el-input-number
                    placeholder="分值"
                    class="score-wrap-score"
                    v-model.trim="data.v31x1.score"
                    :controls="false"
                    :precision="1"
                    :step="0.1"
                    :max="100"
                    :min="0"
                    :value-on-clear="null"
                  />
                </template>
              </taxQue>
            </td>
          </tr>

          <tr class="tr">
            <td class="title01">31.1</td>
            <td class="title01" style="padding-left: 35px">（填写优惠事项名称）</td>
            <td>
              <!-- 考题 -->
              <taxQue :data="data.v31_1x1" :mode="mode">
                <template #input>
                  <el-input-number v-model.trim="data.v31_1x1.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" />
                </template>
                <template #score>
                  <el-input-number placeholder="答案" class="score-wrap-answer" v-model.trim="data.v31_1x1.answer" :controls="false" :precision="2" :step="0.01" :value-on-clear="null" />
                  <el-input-number
                    placeholder="分值"
                    class="score-wrap-score"
                    v-model.trim="data.v31_1x1.score"
                    :controls="false"
                    :precision="1"
                    :step="0.1"
                    :max="100"
                    :min="0"
                    :value-on-clear="null"
                  />
                </template>
              </taxQue>
            </td>
          </tr>

          <tr class="tr">
            <td class="title01">31.2</td>
            <td class="title01" style="padding-left: 35px">（填写优惠事项名称）</td>
            <td>
              <!-- 考题 -->
              <taxQue :data="data.v31_2x1" :mode="mode">
                <template #input>
                  <el-input-number v-model.trim="data.v31_2x1.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" />
                </template>
                <template #score>
                  <el-input-number placeholder="答案" class="score-wrap-answer" v-model.trim="data.v31_2x1.answer" :controls="false" :precision="2" :step="0.01" :value-on-clear="null" />
                  <el-input-number
                    placeholder="分值"
                    class="score-wrap-score"
                    v-model.trim="data.v31_2x1.score"
                    :controls="false"
                    :precision="1"
                    :step="0.1"
                    :max="100"
                    :min="0"
                    :value-on-clear="null"
                  />
                </template>
              </taxQue>
            </td>
          </tr>

          <tr class="tr">
            <td class="title01">32</td>
            <td class="title01" style="padding-left: 35px">减：抵免所得税额（填写A107050）</td>
            <td><el-input-number v-model.trim="data.v32x1.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" /></td>
          </tr>

          <tr class="tr">
            <td class="title01">33</td>
            <td class="title01">七、应纳税额（30－31－32）</td>
            <td>
              <!-- 考题 -->
              <taxQue :data="data.v33x1" :mode="mode">
                <template #input>
                  {{ parseFloatNum(data.v33x1.value) }}
                </template>
                <template #score>
                  <el-input-number placeholder="答案" class="score-wrap-answer" v-model.trim="data.v33x1.answer" :controls="false" :precision="2" :step="0.01" :value-on-clear="null" />
                  <el-input-number
                    placeholder="分值"
                    class="score-wrap-score"
                    v-model.trim="data.v33x1.score"
                    :controls="false"
                    :precision="1"
                    :step="0.1"
                    :max="100"
                    :min="0"
                    :value-on-clear="null"
                  />
                </template>
              </taxQue>
            </td>
          </tr>

          <tr class="tr">
            <td class="title01">34</td>
            <td class="title01" style="padding-left: 35px">加：境外所得应纳所得税额（填写A108000）</td>
            <td><el-input-number v-model.trim="data.v34x1.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" /></td>
          </tr>

          <tr class="tr">
            <td class="title01">35</td>
            <td class="title01" style="padding-left: 35px">减：境外所得抵免所得税额（填写A108000）</td>
            <td><el-input-number v-model.trim="data.v35x1.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" /></td>
          </tr>

          <tr class="tr">
            <td class="title01">36</td>
            <td class="title01" rowspan="10">实际应补（退）税额计算</td>
            <td class="title01">八、实际应纳所得税额（33＋34－35）</td>
            <td>
              <!-- 考题 -->
              <taxQue :data="data.v36x1" :mode="mode">
                <template #input>
                  {{ parseFloatNum(data.v36x1.value) }}
                </template>
                <template #score>
                  <el-input-number placeholder="答案" class="score-wrap-answer" v-model.trim="data.v36x1.answer" :controls="false" :precision="2" :step="0.01" :value-on-clear="null" />
                  <el-input-number
                    placeholder="分值"
                    class="score-wrap-score"
                    v-model.trim="data.v36x1.score"
                    :controls="false"
                    :precision="1"
                    :step="0.1"
                    :max="100"
                    :min="0"
                    :value-on-clear="null"
                  />
                </template>
              </taxQue>
            </td>
          </tr>

          <tr class="tr">
            <td class="title01">37</td>
            <td class="title01" style="padding-left: 35px">减：本年累计预缴所得税额</td>
            <td>
              <!-- 考题 -->
              <taxQue :data="data.v37x1" :mode="mode">
                <template #input>
                  <el-input-number v-model.trim="data.v37x1.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" />
                </template>
                <template #score>
                  <el-input-number placeholder="答案" class="score-wrap-answer" v-model.trim="data.v37x1.answer" :controls="false" :precision="2" :step="0.01" :value-on-clear="null" />
                  <el-input-number
                    placeholder="分值"
                    class="score-wrap-score"
                    v-model.trim="data.v37x1.score"
                    :controls="false"
                    :precision="1"
                    :step="0.1"
                    :max="100"
                    :min="0"
                    :value-on-clear="null"
                  />
                </template>
              </taxQue>
            </td>
          </tr>

          <tr class="tr">
            <td class="title01">38</td>
            <td class="title01">九、本年应补（退）所得税额（36－37）</td>
            <td>
              <!-- 考题 -->
              <taxQue :data="data.v38x1" :mode="mode">
                <template #input>
                  {{ parseFloatNum(data.v38x1.value) }}
                </template>
                <template #score>
                  <el-input-number placeholder="答案" class="score-wrap-answer" v-model.trim="data.v38x1.answer" :controls="false" :precision="2" :step="0.01" :value-on-clear="null" />
                  <el-input-number
                    placeholder="分值"
                    class="score-wrap-score"
                    v-model.trim="data.v38x1.score"
                    :controls="false"
                    :precision="1"
                    :step="0.1"
                    :max="100"
                    :min="0"
                    :value-on-clear="null"
                  />
                </template>
              </taxQue>
            </td>
          </tr>

          <tr class="tr">
            <td class="title01">39</td>
            <td class="title01" style="padding-left: 35px">其中：总机构分摊本年应补（退）所得税额（填写A109000）</td>
            <td><el-input-number v-model.trim="data.v39x1.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" /></td>
          </tr>

          <tr class="tr">
            <td class="title01">40</td>
            <td class="title01" style="padding-left: 70px">财政集中分配本年应补（退）所得税额（填写A109000）</td>
            <td><el-input-number v-model.trim="data.v40x1.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" /></td>
          </tr>

          <tr class="tr">
            <td class="title01">41</td>
            <td class="title01" style="padding-left: 70px">总机构主体生产经营部门分摊本年应补（退）所得税额（填写A109000）</td>
            <td><el-input-number v-model.trim="data.v41x1.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" /></td>
          </tr>

          <tr class="tr">
            <td class="title01">42</td>
            <td class="title01">减：民族自治地区企业所得税地方分享部分：（□ 免征 □ 减征：减征幅度_%）</td>
            <td><el-input-number v-model.trim="data.v42x1.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" /></td>
          </tr>

          <tr class="tr">
            <td class="title01">43</td>
            <td class="title01">减：稽查查补（退）所得税额</td>
            <td><el-input-number v-model.trim="data.v43x1.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" /></td>
          </tr>

          <tr class="tr">
            <td class="title01">44</td>
            <td class="title01">减：特别纳税调整补（退）所得税额</td>
            <td><el-input-number v-model.trim="data.v44x1.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" /></td>
          </tr>

          <tr class="tr">
            <td class="title01">45</td>
            <td class="title01">十、本年实际应补（退）所得税额（38－42－43－44）</td>
            <td>
              <!-- 考题 -->
              <taxQue :data="data.v45x1" :mode="mode">
                <template #input>
                  {{ parseFloatNum(data.v45x1.value) }}
                </template>
                <template #score>
                  <el-input-number placeholder="答案" class="score-wrap-answer" v-model.trim="data.v45x1.answer" :controls="false" :precision="2" :step="0.01" :value-on-clear="null" />
                  <el-input-number
                    placeholder="分值"
                    class="score-wrap-score"
                    v-model.trim="data.v45x1.score"
                    :controls="false"
                    :precision="1"
                    :step="0.1"
                    :max="100"
                    :min="0"
                    :value-on-clear="null"
                  />
                </template>
              </taxQue>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script setup>
import { cloneDeep } from "lodash";
import Big from "big.js";
import { reportTaxDateConfig } from "../../reportTaxStaticConfig.js";
import taxQue from "../../cmp/taxQue.vue";
import { syncAnswer } from "../../cmjs/index.js";

const currentQa = inject("provideCurrentQa");
const staticConfig = computed(() => reportTaxDateConfig(currentQa.value).staticConfig);

const isInit = ref(false);
const mode = ref(null);

// 初始数据
const taxDataAll = ref({});
const taxData = ref({});
const data = ref({});
// 初始化
const init = (options = {}) => {
  mode.value = options.mode;
  taxDataAll.value = cloneDeep(options.taxDataAll);
  // 当前数据
  taxData.value = cloneDeep(options.taxData);
  // 当前数据的表单数据
  data.value = cloneDeep(options.taxData.data);
  watchStart();
  isInit.value = true;
};
// 返回数据
const getData = () => {
  if (!isInit.value) {
    return;
  }

  return toRaw(data.value);
};

const watchData = computed(() => cloneDeep(data.value));
function watchStart() {
  watch(
    watchData,
    (newVal, oldVal) => {
      try {
        // 15=1-2-3-4-5-6-7+8+9
        data.value.v15x1.value = new Big(data.value.v1x1.value)
          .minus(data.value.v2x1.value)
          .minus(data.value.v3x1.value)
          .minus(data.value.v4x1.value)
          .minus(data.value.v5x1.value)
          .minus(data.value.v6x1.value)
          .minus(data.value.v7x1.value)
          .plus(data.value.v8x1.value)
          .plus(data.value.v9x1.value)
          .round(2)
          .toNumber();
        // 18=15+16-17
        data.value.v18x1.value = new Big(data.value.v15x1.value).plus(data.value.v16x1.value).minus(data.value.v17x1.value).round(2).toNumber();
        // 22=22.1+22.2
        data.value.v22x1.value = new Big(data.value.v22_1x1.value).plus(data.value.v22_2x1.value).round(2).toNumber();
        // 24=18-19+20-21-22+23
        data.value.v24x1.value = new Big(data.value.v18x1.value)
          .minus(data.value.v19x1.value)
          .plus(data.value.v20x1.value)
          .minus(data.value.v21x1.value)
          .minus(data.value.v22x1.value)
          .plus(data.value.v23x1.value)
          .round(2)
          .toNumber();
        // 28=24-25-26-27
        data.value.v28x1.value = new Big(data.value.v24x1.value).minus(data.value.v25x1.value).minus(data.value.v26x1.value).minus(data.value.v27x1.value).round(2).toNumber();
        // 30=28*29
        data.value.v30x1.value = new Big(data.value.v28x1.value).times(data.value.v29x1.value).round(2).toNumber();
        // 31=31.1+31.2
        data.value.v31x1.value = new Big(data.value.v31_1x1.value).plus(data.value.v31_2x1.value).round(2).toNumber();
        // 33=30-31-32
        data.value.v33x1.value = new Big(data.value.v30x1.value).minus(data.value.v31x1.value).minus(data.value.v32x1.value).round(2).toNumber();
        // 36=33+34-35
        data.value.v36x1.value = new Big(data.value.v33x1.value).plus(data.value.v34x1.value).minus(data.value.v35x1.value).round(2).toNumber();
        // 38=36-37
        data.value.v38x1.value = new Big(data.value.v36x1.value).minus(data.value.v37x1.value).round(2).toNumber();
        // 45=38-42-43-44
        data.value.v45x1.value = new Big(data.value.v38x1.value).minus(data.value.v42x1.value).minus(data.value.v43x1.value).minus(data.value.v44x1.value).round(2).toNumber();

        syncAnswer({
          mode,
          newVal,
          oldVal,
          data,
        });
      } catch (e) {
        console.log(e);
      }
    },
    {
      deep: true,
      immediate: true,
    }
  );
}

// 小数点
function parseFloatNum(s, num = 2) {
  try {
    return new Big(s).toFixed(num);
  } catch (e) {}
}

defineExpose({
  init,
  getData,
});
</script>

<style scoped lang="scss">
.tax-table-wrap {
}

.tax-table-wrap-tax53 table {
  tbody {
    tr {
      td {
        &:nth-of-type(2) {
          text-align: left !important;
        }
      }

      &:nth-of-type(1),
      &:nth-of-type(19),
      &:nth-of-type(31),
      &:nth-of-type(40) {
        td {
          &:nth-of-type(3) {
            text-align: left !important;
          }

          &:nth-of-type(2) {
            text-align: center !important;
          }
        }
      }
    }
  }
}
</style>

<script>
const tableHtml = `
<table border="1" cellspacing="1" cellpadding="0" tabletype="2024033104">
  <thead>
    <tr>
      <td class="title01" width="5%">行次</td>
      <td class="title01" width="15%">类别</td>
      <td class="title01" width="60%">项目</td>
      <td class="title01" width="20%">金额</td>
    </tr>
  </thead>
  <tbody>
    <tr class="tr">
      <td class="title01">1</td>
      <td class="title01" rowspan="13">利润总额计算</td>
      <td class="title01">一、营业收入（填写A101010\\101020\\103000）</td>
      <td><input type="text" value="0" class="i1 input2" daan="10821684.02" /></td>
    </tr>
    <tr class="tr">
      <td class="title01">2</td>
      <td class="title01">减：营业成本（填写A102010\\102020\\103000）</td>
      <td><input type="text" value="0" class="i2 input2" daan="7579607.84" /></td>
    </tr>
    <tr class="tr">
      <td class="title01">3</td>
      <td class="title01">减：税金及附加</td>
      <td><input type="text" value="0" class="i3 input2" daan="24066.53" /></td>
    </tr>
    <tr class="tr">
      <td class="title01">4</td>
      <td class="title01">减：销售费用（填写A104000）</td>
      <td><input type="text" value="0" class="i4 input2" daan="1643672.64" /></td>
    </tr>
    <tr class="tr">
      <td class="title01">5</td>
      <td class="title01">减：管理费用（填写A104000）</td>
      <td><input type="text" value="0" class="i5 input2" daan="833567.42" /></td>
    </tr>
    <tr class="tr">
      <td class="title01">6</td>
      <td class="title01">减：财务费用（填写A104000）</td>
      <td><input type="text" value="0" class="i6 input2" daan="13801.27" /></td>
    </tr>
    <tr class="tr">
      <td class="title01">7</td>
      <td class="title01">减：资产减值损失</td>
      <td><input type="text" value="0" class="i7 input2" daan="0.00" /></td>
    </tr>
    <tr class="tr">
      <td class="title01">8</td>
      <td class="title01">加：公允价值变动收益</td>
      <td><input type="text" value="0" class="i8 input2" daan="0.00" /></td>
    </tr>
    <tr class="tr">
      <td class="title01">9</td>
      <td class="title01">加：投资收益</td>
      <td><input type="text" value="0" class="i9 input2" daan="0.00" /></td>
    </tr>
    <tr class="tr">
      <td class="title01">10</td>
      <td class="title01">二、营业利润(1－2－3－4－5－6－7＋8＋9)</td>
      <td><input type="text" value="0" class="i10 input2" daan="726968.32" /></td>
    </tr>
    <tr class="tr">
      <td class="title01">11</td>
      <td class="title01">加：营业外收入（填写A101010）</td>
      <td><input type="text" value="0" class="i11 input2" daan="3150.84" /></td>
    </tr>
    <tr class="tr">
      <td class="title01">12</td>
      <td class="title01">减：营业外支出（填写A102010）</td>
      <td><input type="text" value="0" class="i12 input2" daan="27340.00" /></td>
    </tr>
    <tr class="tr">
      <td class="title01">13</td>
      <td class="title01">三、利润总额（10＋11－12）</td>
      <td><input type="text" value="0" class="i13 input2" daan="702779.16" /></td>
    </tr>
    <tr class="tr">
      <td class="title01">14</td>
      <td class="title01" rowspan="10">应纳税所得额计算</td>
      <td class="title01">减：境外所得（填写A108010）</td>
      <td><input type="text" value="0" class="i14 input1" daan="0.00" /></td>
    </tr>
    <tr class="tr">
      <td class="title01">15</td>

      <td class="title01">加：纳税调整增加额（填写A105000）</td>
      <td><input type="text" value="0" class="i15 input1" readonly="" daan="31433.02" /></td>
    </tr>
    <tr class="tr">
      <td class="title01">16</td>
      <td class="title01">减：纳税调整减少额（填写A105000）</td>
      <td><input type="text" value="0" class="i16 input1" readonly="" daan="0.00" /></td>
    </tr>
    <tr class="tr">
      <td class="title01">17</td>
      <td class="title01">减：免税、减计收入及加计扣除（填写A107010）</td>
      <td><input type="text" value="0" class="i17 input1" daan="0.00" /></td>
    </tr>
    <tr class="tr">
      <td>18</td>
      <td class="title01">加：境外应税所得抵减境内亏损（填写A108000）</td>
      <td class="title01"><input type="text" value="0" class="i18 input1" daan="0.00" /></td>
    </tr>
    <tr class="tr">
      <td class="title01">19</td>
      <td class="title01">四、纳税调整后所得（13-14+15-16-17+18）</td>
      <td><input type="text" value="0" class="i19 input1" daan="734212.18" /></td>
    </tr>
    <tr class="tr">
      <td class="title01">20</td>
      <td class="title01">减：所得减免（填写A107020）</td>
      <td><input type="text" value="0" class="i20 input1" daan="0.00" /></td>
    </tr>
    <tr class="tr">
      <td class="title01">21</td>
      <td class="title01">减：弥补以前年度亏损（填写A106000）</td>
      <td><input type="text" value="0" class="i21 input1" readonly="" daan="12763.88" /></td>
    </tr>
    <tr class="tr">
      <td class="title01">22</td>
      <td class="title01">减：抵扣应纳税所得额（填写A107030）</td>
      <td><input type="text" value="0" class="i22 input1" daan="0.00" /></td>
    </tr>
    <tr class="tr">
      <td class="title01">23</td>
      <td class="title01">五、应纳税所得额（19-20-21-22）</td>
      <td><input type="text" value="0" class="i23 input1" readonly="" daan="721448.30" /></td>
    </tr>
    <tr class="tr">
      <td class="title01">24</td>
      <td class="title01" rowspan="13">应纳税额计算</td>
      <td class="title01">税率（25%）</td>
      <td class="title01" style="text-align: right; padding-right: 15px">25%</td>
    </tr>
    <tr class="tr">
      <td class="title01">25</td>
      <td class="title01">六、应纳所得税额（23*24）</td>
      <td><input type="text" value="0" class="i25 input1" daan="180362.07" /></td>
    </tr>
    <tr class="tr">
      <td class="title01">26</td>
      <td class="title01">减：减免所得税额（填写A107040）</td>
      <td><input type="text" value="0" readonly="" class="i26 input1" daan="144289.66" /></td>
    </tr>
    <tr class="tr">
      <td class="title01">27</td>
      <td class="title01">减：抵免所得税额（填写A107050）</td>
      <td><input type="text" value="0" class="i27 input1" daan="0.00" /></td>
    </tr>
    <tr class="tr">
      <td class="title01">28</td>
      <td class="title01">七、应纳税额（25-26-27）</td>
      <td><input type="text" value="0" class="i28 input1" daan="36072.41" /></td>
    </tr>
    <tr class="tr">
      <td class="title01">29</td>
      <td class="title01">加：境外所得应纳所得税额（填写A108000）</td>
      <td><input type="text" value="0" class="i29 input1" daan="0.00" /></td>
    </tr>
    <tr class="tr">
      <td class="title01">30</td>
      <td class="title01">减：境外所得抵免所得税额（填写A108000）</td>
      <td><input type="text" value="0" class="i30 input1" daan="0.00" /></td>
    </tr>
    <tr class="tr">
      <td class="title01">31</td>
      <td class="title01">八、实际应纳所得税额（28+29-30）</td>
      <td><input type="text" value="0" class="i31 input1" daan="36072.41" /></td>
    </tr>
    <tr class="tr">
      <td class="title01">32</td>
      <td class="title01">减：本年累计实际已缴纳的所得税额</td>
      <td><input type="text" value="0" class="i32 input1" daan="35138.96" /></td>
    </tr>
    <tr class="tr">
      <td class="title01">33</td>
      <td class="title01">九、本年应补（退）所得税额（31-32）</td>
      <td><input type="text" value="0" class="i33 input1" daan="933.45" /></td>
    </tr>
    <tr class="tr">
      <td class="title01">34</td>
      <td class="title01">其中：总机构分摊本年应补（退）所得税额（填写A109000）</td>
      <td><input type="text" value="0" class="i34 input1" daan="0.00" /></td>
    </tr>
    <tr class="tr">
      <td class="title01">35</td>
      <td class="title01">财政集中分配本年应补（退）所得税额（填写A109000）</td>
      <td><input type="text" value="0" class="i35 input1" daan="0.00" /></td>
    </tr>
    <tr class="tr">
      <td class="title01">36</td>
      <td class="title01">总机构主体生产经营部门分摊本年应补（退）所得税额（填写A109000）</td>
      <td><input type="text" value="0" class="i36 input1" daan="0.00" /></td>
    </tr>
    <tr class="tr">
      <td class="title01">37</td>
      <td class="title01" rowspan="2">实际缴纳企业所得税计算</td>
      <td class="title01">本年民族自治地区地方分享部分优惠方式</td>
      <td>
        <input type="radio" name="youhui" value="0.00" style="width: 15px; margin-left: 5px" />免征 <input type="radio" name="youhui" value="0.00" style="width: 15px; margin-left: 5px" />减征
        <input type="radio" name="youhui" value="0.00" style="width: 15px; margin-left: 5px" />否
        <input type="text" value="0" class="i37 input1">
      </td>
    </tr>
    <tr class="tr">
      <td class="title01">38</td>
      <td class="title01">十、本年实际应补（退）所得税额（33-37）</td>
      <td><input type="text" value="0" class="i38 input1" readonly="" daan="933.45" /></td>
    </tr>
  </tbody>
</table>
`;

function replaceHtml(str) {
  let s = str.replace(/(<div([^>]*)>)|(<\/div>)/gi, "");
  s = s.replace(/(<span([^>]*)>)|(<\/span>)/gi, "");
  s = s.replace(/<input.*type="text".*>/g, '<el-input-number v-model.trim="defaultValue" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.00" />');

  return s;
}

const defaultValue = ref(0);
// console.log(replaceHtml(tableHtml), "tableHtml");
</script>
